"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.prefixes = exports.hosts = exports.config = exports.baseValues = void 0;
var _utils = require("@site/utils");
const baseValues = exports.baseValues = {
  auctionContinue: '/trpItemListing.aspx',
  contentApi: '/content/SERP/v1',
  crossSellGet: '/domainfind/v1/crosssell/all',
  exactGet: '/domainfind/v1/search/exact',
  exactMatchGet: '/domainfind/v1/search/exactMatch',
  divinerGet: '/domainfind/v1/diviner',
  afterMarketAuctionRecommend: '/v4/aftermarket/find/auction/recommend',
  basketGet: '/v1/pl/{privateLabelId}/cart',
  sapiCartPackages: '/v1/pl/{privateLabelId}/cart/packages',
  sapiCartDomains: '/v1/pl/{privateLabelId}/cart/domains',
  bundleGet: '/domainfind/v1/bundles',
  smartBundleGet: '/domainfind/v1/search/smartbundles',
  smartExactGet: '/domainfind/v1/search/smartexact',
  solutionImages: '/serpimg/img/solutionsimg/',
  spinsGet: '/domainfind/v1/search/spins',
  sslHelpUrl: '/help/ssl-certificates-1000006',
  support: '/v1/plid/1/contacts',
  deepIndustryGet: '/domainfind/v1/deepindustry',
  queryComplete: '/domainfind/autocomplete',
  uipApi: '/v1/users/insights/{endpoint}',
  getDomainSearchComponentBFFApi: '/domainsearch/api/getComponentData',
  merchRecommend: '/domainfind/v1/merchrecommend/domain',
  logoGeneration: '/v1/go-caas/logo',
  logoBatchGeneration: '/batches',
  domainSuggestions: '/v1/customers/{customerId}/domainSuggestions',
  dccDomainsGet: '/v2/customers/{customerId}/domains/get',
  llcAvailCheck: '/v1/formations/name-availability',
  addToCartTrack: '/domainfind/v1/addtocart',
  productGraphApi: '/v1/gql/customer',
  tokenApi: '/v1/tokens'
};
const prefixes = exports.prefixes = {
  find: 'https://',
  reseller: 'https://www.',
  sapi: 'https://salesproducts.api.',
  uip: 'https://uip.',
  genAi: 'https://mvci.api.',
  genAiBatch: 'https://batch-logo-generation.',
  llcAvailCheck: 'https://api.',
  productGraph: 'https://pg.api.',
  tokenApi: 'https://'
};
const hosts = exports.hosts = {
  dev: {
    auction: 'auctions.dev-godaddy.com',
    find: 'dev-godaddy.com',
    reseller: 'dev-secureserver.net',
    entourage: 'entourage.dev.aws.godaddy.com',
    dccDomains: 'domains.dcc.api.dev-godaddy.com',
    llcAvailCheck: 'tailorbrands.com',
    findAftermarket: 'find.tls.dev.aws.godaddy.com',
    tokenApi: 'merch.dev-godaddy.com',
    mvcApi: 'mvciapi.dev.aws.gdcld.net'
  },
  prod: {
    auction: 'auctions.godaddy.com',
    find: 'godaddy.com',
    reseller: 'secureserver.net',
    entourage: 'entourage.prod.aws.godaddy.com',
    dccDomains: 'domainsapi.godaddy.com',
    llcAvailCheck: 'tailorbrands.com',
    findAftermarket: 'find.tls.prod.aws.godaddy.com',
    tokenApi: 'merch.godaddy.com',
    mvcApi: 'mvciapi.prod.aws.gdcld.net'
  },
  test: {
    auction: 'auctions.test-godaddy.com',
    find: 'test-godaddy.com',
    reseller: 'test-secureserver.net',
    entourage: 'entourage.test.aws.godaddy.com',
    dccDomains: 'domains.dcc.api.test-godaddy.com',
    llcAvailCheck: 'tailorbrands.com',
    findAftermarket: 'find.tls.test.aws.godaddy.com',
    tokenApi: 'merch.test-godaddy.com',
    mvcApi: 'mvciapi.stage.aws.gdcld.net'
  }
};
const config = exports.config = {
  getSubDomainAndLanguage: (marketCookie = 'en-US') => {
    return _utils.Markets[marketCookie] || _utils.Markets['en-US'] || {
      subDomain: 'www',
      languagePath: null
    };
  },
  isValidEnv: env => {
    const envValues = ['prod', 'dev', 'test'];
    return envValues.includes(env);
  },
  isReseller: plid => {
    return !(plid === '1' || plid === 1);
  },
  getPaths: env => {
    const paths = {
      dev: baseValues,
      test: baseValues,
      prod: baseValues
    };
    return paths[env];
  },
  getPrefixes: (isReseller, subDomain = 'www') => {
    return isReseller ? prefixes.reseller : `${prefixes.find}${subDomain}.`;
  },
  _getHostForEnvironment: (env, isReseller, resellerBaseOverride) => {
    return isReseller ? resellerBaseOverride || hosts[env].reseller : hosts[env].find;
  },
  _buildHostUrl: (prefix, host, languagePath, isReseller) => {
    return languagePath && !isReseller ? `${prefix}${host}/${languagePath}` : `${prefix}${host}`;
  },
  getHosts: (env = 'prod', plid = 1, market = 'en-US', options = {}) => {
    const {
      resellerBaseOverride,
      isServerCall = false
    } = options;
    if (!hosts[env]) return;
    if (isServerCall) {
      return config.getEntourageHost(env);
    }
    const {
      subDomain,
      languagePath
    } = config.getSubDomainAndLanguage(market);
    const isReseller = config.isReseller(plid);
    const prefix = config.getPrefixes(isReseller, subDomain);
    const host = config._getHostForEnvironment(env, isReseller, resellerBaseOverride);
    return config._buildHostUrl(prefix, host, languagePath, isReseller);
  },
  getSapiHost: (env = 'prod', plid = 1, resellerBaseOverride) => {
    if (!hosts[env]) return;
    const host = config.isReseller(plid) ? resellerBaseOverride || hosts[env].reseller : hosts[env].find;
    return `${prefixes.sapi}${host}`;
  },
  getGenAiHost: (env = 'prod', plid = 1, resellerBaseOverride) => {
    if (!hosts[env]) return;
    const host = config.isReseller(plid) ? resellerBaseOverride || hosts[env].reseller : hosts[env].find;
    return `${prefixes.genAi}${host}`;
  },
  getGenAiBatchHost: (env = 'prod') => {
    if (!hosts[env]) return;
    const host = hosts[env].mvcApi;
    return `${prefixes.genAiBatch}${host}`;
  },
  getUipHost: (env = 'prod') => {
    if (!hosts[env]) return;
    const host = hosts[env].find;
    return `${prefixes.uip}${host}`;
  },
  getAuctionsHost: (env = 'prod', plid = 1, market = 'en-US') => {
    if (!hosts[env]) return;
    const {
      subDomain,
      languagePath
    } = config.getSubDomainAndLanguage(market);
    const isReseller = config.isReseller(plid);
    const prefix = config.getPrefixes(isReseller, subDomain);
    const host = hosts[env].auction;
    const paths = config.getPaths(env);
    return `${prefix}${host}${languagePath && !isReseller ? `/${languagePath}` : ''}${paths.auctionContinue}`;
  },
  getDccDomainsHost: (env = 'prod') => {
    if (!hosts[env]) return;
    const host = hosts[env].dccDomains;
    return `${prefixes.find}${host}`;
  },
  getLLCAvailCheckApiHost: (env = 'prod') => {
    if (!hosts[env]) return;
    const host = hosts[env].llcAvailCheck;
    return `${prefixes.llcAvailCheck}${host}`;
  },
  getFindAftermarketHost: (env = 'prod') => {
    if (!hosts[env]) return;
    const host = hosts[env].findAftermarket;
    return `${prefixes.find}${host}`;
  },
  getProductGraphHost: (env = 'prod') => {
    if (!hosts[env]) return;
    const host = hosts[env].find;
    return `${prefixes.productGraph}${host}`;
  },
  getTokenApiHost: (env = 'prod') => {
    if (!hosts[env]) return;
    const host = hosts[env].tokenApi;
    return `${prefixes.tokenApi}${host}`;
  },
  getEntourageHost: (env = 'prod') => {
    if (!hosts[env]) return;
    const host = hosts[env].entourage;
    return `${prefixes.find}${host}`;
  }
};